import React, { useEffect } from "react";

import Businessdropdown from "../Business/Businessdropdown";
import Businesspagination from "../Business/Businesspagination";
import BusinessTable from "../Business/BusinessTable";
import Navbars from "../Navbars";
import Sidebar from "../profile/Sidebar";
import "./list.css";
import ListTable from "./ListTable";
import Listtabs from "./Listtabs";
import { useDispatch, useSelector } from "react-redux";
import BuySellTabs from "./BuySellTabs";
// import { getBusiness } from "../../store/getBusiness";

function BuySell(props) {
  // const getBusinessData = useSelector((state) => state.getBusiness.data);
  // const loading = useSelector((state) => state.getBusiness.isLoading);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   console.log("isLoading: ", loading);
  // }, [loading]);
  // //   useEffect(() => {
  // //     console.log("getBusinessData: ", getBusinessData);
  // //   }, [getBusinessData]);

  // useEffect(() => {
  //   dispatch(getBusiness());
  // }, []);

  return (
    <>
      <div
        className="conatiner-fluid"
        style={{
          backgroundColor: "#F5F5F5",
          position: "relative",
          height: "100vh",
        }}
      >
        <Navbars show="none" />
        <div className="d-flex gap-2 pe-3 main_div w-100">
          <Sidebar />
          <div className="table_outer ">
            <div className="d-flex gap-2 align-items-start table_outer_body">
              {/* <div style={{ display: "flex", flexDirection: "column" }}>
                <input type="radio" className="business_radio4" />
                <input type="radio" className="business_radio2" />
                <input type="radio" className="business_radio2" />
                <input type="radio" className="business_radio2" />
                <input type="radio" className="business_radio2" />
              </div> */}
              <div
                className="inner_div2    pt-2  mb-3 pb-4 pt-4 table_width"
                style={{ width: "100%" }}
              >
                
                <div
                  className="business_drop business_drop2"
                  style={{ marginTop: "20px", marginBottom: "10px" }}
                >
                  <BuySellTabs id={props}/>
                </div>
                {/* <Businesspagination /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BuySell;
